import React, { Component } from 'react';
import XLSX from 'xlsx';
import SheetJSFT from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import {validaCPF} from 'utils/cpf-utils';

class ExcelReader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      file: {},
      data: [],
      cols: []
    }
    this.ref = React.createRef();
    this.handleFile = this.handleFile.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
 
  handleChange(e) {
    const files = e.target.files;
    if (files && files[0]) this.setState({ file: files[0] });

    this.handleFile(files[0]);

  };
 
  handleFile(file) {
    /* Boilerplate to set up FileReader */
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;
 
    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA : true });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws);
      /* Update state */
      // this.setState({ data: data, cols: make_cols(ws['!ref']) }, () => {
      //   console.log(JSON.stringify(this.state.data, null, 2));
      // });

      var i;

      for(i = 0; i < data.length; i++){
        data[i].valid = validaCPF(data[i].CPF);
      }

      this.props.onFileSelected(data);
      
    };
 
    if (rABS) {
      reader.readAsBinaryString(file);
    } else {
      reader.readAsArrayBuffer(file);
    };
  }
 
  render() {
    return (
      <>
        <button className="btn-upload-list" onClick={() => this.ref.current.click()}><FontAwesomeIcon icon={faDownload} />Carregar lista</button>
        <input type="file" ref={this.ref} className="hide" id="file" accept={SheetJSFT} onChange={this.handleChange} />
      </>
    )
  }
}
 
export default ExcelReader;